export default __webpack_public_path__ + "static/genopets-4-b-d2539441c96c07f5f1f0c50cd94f3f47.webp";